/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Action_LabelInputs */



/**
* | output |
* | --- |
* | "Action point" |
*
* @param {Meeting_Prep_Action_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_action_label = /** @type {((inputs?: Meeting_Prep_Action_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Action_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Actiepunt")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Point d'action")
	return /** @type {LocalizedString} */ ("Action point")
});